import { BaseSearchbarHistoryItem, SearchbarHistoryItem } from '../../redux/searchbar/types'
import { getSearchDate } from '../../utils/miscellaneous-utils'
import { HeroSlideTransport, PopularDestinationTransport } from '../../transports/region-landing-page-transport'
import { trackingClient } from '../../clients'
import {
    DESKTOP_IMAGE_RESIZE_WIDTH,
    LARGE_MOBILE_IMAGE_RESIZE_WIDTH,
    MEDIUM_MOBILE_IMAGE_RESIZE_WIDTH,
    SMALL_MOBILE_IMAGE_RESIZE_WIDTH,
    WIDE_SCREEN_IMAGE_RESIZE_WIDTH,
} from '../../common/responsive-config-constants'
import { ListingSectionObject } from '../../transports/common/listing-section-transport'
import { isServer } from '../../utils/platform-utils'

export interface MobileSlidesConfig {
    smallMobile: number
    defaultMobile: number
}

export const getMobileVisibleSlides = ({ smallMobile, defaultMobile }: MobileSlidesConfig): number => {
    if (isServer) {
        return defaultMobile
    }

    const width = window.innerWidth

    if (width < 400) {
        return smallMobile
    }

    return defaultMobile
}

export const verifyEmail = (email: string) => {
    const mailFormat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
    return mailFormat.test(email)
}

export const dateToString = (date: Date | null, separtor: string, reverse = false) => {
    if (!date) {
        return null
    }
    const data = [
        date.getDate().toString().padStart(2, '0'),
        (date.getMonth() + 1).toString().padStart(2, '0'),
        date.getFullYear(),
    ]

    return reverse ? data.reverse().join(separtor) : data.join(separtor)
}

export const getPropertyClickRedirectUrl = (baseUrl: string, href: string) => {
    try {
        return new URL(href)
    } catch {
        return new URL(href, baseUrl)
    }
}

export const trackListings = (body: any) => {
    trackingClient.trackRegionLandingPageListings(body).then()
}

export const slugifyText = (text: string): string =>
    text
        .toLowerCase()
        .replace(/ß/g, 'ss') // handle german sharp S
        .normalize('NFD') // split accents from letters
        .replace(/[\u0300-\u036F]/g, '') // remove accents
        .replace(/[^\da-z]+/g, '-') // replace non-alphanumeric with dash
        .replace(/(^-|-$)/g, '') // trim leading/trailing dashes
